import { FieldError, UseFormSetValue } from 'react-hook-form'
import { DateTimePickerField } from 'utoniq-ui'

import { CreateItemProps } from '@/components/pages/ConsoleItemCreate/template/ItemCreateForm'
import { useTranslation } from '@/core'
import { Cell, CellFrame } from '@/core/architecture'
import { convertDatePickerValueToDate, dayjs } from '@/lib/dayjs'

type AvailableDateInputCellProps = {
  values: string[]
  setValue: UseFormSetValue<CreateItemProps>
  errors: (FieldError | undefined)[]
}
export const AvailableDateInputCell: Cell<AvailableDateInputCellProps> = ({
  values,
  setValue,
  errors,
}) => {
  const { t } = useTranslation('consoleItemCreate')
  return (
    <>
      <CellFrame sx={{ pb: 6 }}>
        <DateTimePickerField
          onChange={date => {
            setValue(
              'metadata.ticket.startDateOfUse',
              (convertDatePickerValueToDate(date) || '') as never,
              {
                shouldValidate: true,
                shouldDirty: true,
              }
            )
          }}
          value={values[0] ? dayjs(values[0]) : null}
          placeholder={t('datePlaceholder')}
          error={errors[0]}
          title={t('availableDateStartLabel')}
          titleProps={{ variant: 'h5', color: 'text.primary' }}
        />
      </CellFrame>
      <CellFrame sx={{ pb: 6 }}>
        <DateTimePickerField
          onChange={date => {
            setValue(
              'metadata.ticket.endDateOfUse',
              (convertDatePickerValueToDate(date) || '') as never,
              {
                shouldValidate: true,
                shouldDirty: true,
              }
            )
          }}
          value={values[1] ? dayjs(values[1]) : null}
          placeholder={t('datePlaceholder')}
          error={errors[1]}
          title={t('availableDateEndLabel')}
          titleProps={{ variant: 'h5', color: 'text.primary' }}
        />
      </CellFrame>
    </>
  )
}
